import type { ReactNode } from 'react';

import { WhaleProvider } from '@rango-dev/whale';
import React from 'react';

import { useAppSelector } from '../../hooks/reduxHooks';
import './WhaleThemeProvider.styles.css';

type WhaleThemeProviderProps = {
  children: ReactNode;
};

export const WhaleThemeProvider = (props: WhaleThemeProviderProps) => {
  const isDarkMode = useAppSelector((state) => state.settings.isDarkMode);

  return <WhaleProvider appearance={isDarkMode ? 'dark' : 'light'}>{props.children}</WhaleProvider>;
};
